import { PageTitle } from '@/components/seo/page-title';
import { SettingsScreen } from '@/screens/settings/settings-screen';
import { useAuth } from '@/hooks/use-auth';
import React from 'react';

export default function SettingsRoute() {
  const { logout } = useAuth();

  const handleSignOut = async () => {
    try {
      await logout();
    } catch (error) {
      if (__DEV__) {
        console.error('Sign out error:', error);
      }
    }
  };

  return (
    <>
      <PageTitle title="Settings" />
      <SettingsScreen onSignOut={handleSignOut} />
    </>
  );
}
